/// <reference path="../ObjectDataBuilder.ts" />
/// <reference path="../Navigation.ts" />

namespace SPA
{
	export namespace Realtor
	{

		export class BuildingBuilder
			extends ObjectDataBuilder<Wollmilch.Data.Building>
		{
			private	m_Name: ui.Box.Box;
			private	m_General: ui.Box.Box;
			private	m_Applicability: ui.Box.Box;
			private	m_Heating: ui.Box.Box;

			private m_Form: ui.Form.Form;

			private Navigation: Navigation;

			public constructor( data: Wollmilch.Data.Building, navigation: Navigation  )
			{
				super( data );

				this.Navigation = navigation;

				this.m_Name						= new ui.Box.Box();
				this.m_General				= new ui.Box.Box();
				this.m_Applicability	= new ui.Box.Box();
				this.m_Heating				= new ui.Box.Box();

				this.m_Form 					= new ui.Form.Form(
					{
						action: 'building/update/' + this.m_Data.ID,
						method: 'PATCH',
						static: false,
						notSwitchable: true,
						submit: ( method: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter  ) =>
						{
							new Wollmilch.AJAX(
								{
									method,
									url: action,
									data: parameter,
									on:
									{
										success: ( text: string ): void =>
										{
											const obj = Wollmilch.jsonize( text );

											if ( obj && obj.success === true )
											{
												app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getSpanMessage( 'Aux.BASIC.OBJECT.REALTOR.BUILDING.success_edit' ) ], context: 'success' });
											}
											else
											{
												app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getSpanMessage( 'Aux.BASIC.OBJECT.REALTOR.BUILDING.error_edit' ) ], context: 'danger' });
											}
										}
									}
								},
								Wollmilch.AJAXCallbase_e.REALTOR
							).send();
						}
					}
				);
				this.m_Form.Initialize();
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement>, navigation: Navigation ): BuildingBuilder
			{
				this.m_Form.rebuild( root.empty() );

				this.showCompleteBuilding();

				return this;
			}

			public afterBuild(): void
			{
				this.Navigation.addRegister( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.BUILDING.LABEL.modernization' ), new SPA.Realtor.ModernizationBuilder( this.m_Data, this.Navigation ) );

				if ( this.m_Data.Unit )
				{
					this.m_Data.Unit.forEach( ( unit ) =>
					{
						this.Navigation.addRegister( unit.Name ? unit.Name : app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.BUILDING.LABEL.new_unit' ), new SPA.Realtor.UnitBuilder( unit ) );
					});
				}
			}

			private showCompleteBuilding(): void
			{
				this.showBuildingName();
				this.showBuildingGeneral();
				this.showBuildingApplicability();
				this.showBuildingHeating();

				new ui.Box.Box()
					.append( $( this.m_Form.Buttons.submit.getElement() ).text( app.getMessage( 'Aux.SAVE_BTN' ) ) )
					// .append( $( this.m_Form.Buttons.reset.getElement() ).text( app.getMessage( 'Aux.RESET_BTN' ) ) )
					.append( $( this.m_Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ) )
				.appendTo( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// addUnit
				this.m_Form.append(
					$( new Button(
						{ title: app.getSpanMessage( 'Aux.BASIC.OBJECT.REALTOR.BUILDING.LABEL.new_unit' ),
							on:
							{
								click: () =>
								{
									const t = new Wollmilch.AJAX(
										{
											method: 'POST',
											url: 'building/addUnit/' + this.m_Data.ID,
											on:
											{
												success: ( text: string ): void =>
												{
													const obj = Wollmilch.jsonize( text );
													if ( obj && obj.success === true )
													{
														this.Navigation.addRegister( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.BUILDING.LABEL.new_unit' ), new SPA.Realtor.UnitBuilder( obj.data ) );
														app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.UNIT.success_new' ) ], context: 'success' });
													}
													else
													{
														app.addToast({ timeout: Number(app.getConfigValue("ToastTimeout")), body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.UNIT.error_new' ) ], context: 'danger' });
													}
												}
											}
										},
										Wollmilch.AJAXCallbase_e.REALTOR
										).send();

								}
							}
						}
					).getElement() )
				);

			}

			private showBuildingName(): void
			{
				this.m_Name.clearTitle();
				this.m_Name.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.BUILDING.name' ) );
				this.m_Name.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Name des Gebäudes
				const fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group clearfix' ).appendTo( this.m_Name.Root() );
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Name,
						{
							name: 'name',
							placeholder: '',
							required: true
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-12' ]
				);

			}

			private showBuildingGeneral(): void
			{
				this.m_General.clearTitle();
				this.m_General.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.BUILDING.General' ) );
				this.m_General.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Gebäudeart
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'General.BuildingKind',
							required: false,
							inline: 5,
							value: this.m_Data.Data.General.BuildingKind || undefined,
							radioButtons:
							[
								{
									value: 'FamilyHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.FamilyHouse' ),
									descriptor: {}
								},
								{
									value: 'SemiHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.SemiHouse' ),
									descriptor: {}
								},
								{
									value: 'EndHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.EndHouse' ),
									descriptor: {}
								},
								{
									value: 'MiddleHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.MiddleHouse' ),
									descriptor: {}
								},
								{
									value: 'ApartmentHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.ApartmentHouse' ),
									descriptor: {}
								},
								{
									value: 'LivingAndBusinessHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.LivingAndBusinessHouse' ),
									descriptor: {}
								},
								{
									value: 'Apartment',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.Apartment' ),
									descriptor: {}
								},
								{
									value: 'OfficeBuilding',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.OfficeBuilding' ),
									descriptor: {}
								},
								{
									value: 'RepairShop',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.RepairShop' ),
									descriptor: {}
								},
								{
									value: 'StoreHouse',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.StoreHouse' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() )
							.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.General.BuildingKind' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
							.appendTo( this.m_General.Root() )
					),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Bauweise
				{
					const values: string[] = [];

 				for ( const i in this.m_Data.Data.General.Construction )
					{
						if ( this.m_Data.Data.General.Construction[ i ] ) { values.push( i.toLowerCase() ); }
					}
					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'General.Construction',
								required: false,
								inline: 4,
								value: values,
								checkboxes:
								[
									{
										name: 'solid',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Construction.solid' ),
										descriptor: {}
									},
									{
										name: 'timberframed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Construction.timberframed' ),
										descriptor: {}
									},
									{
										name: 'prefabricatedhouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Construction.prefabricatedhouse' ),
										descriptor: {}
									},
									{
										name: 'timber',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Construction.timber' ),
										descriptor: {}
									},
									{
										name: 'loamhouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Construction.loamhouse' ),
										descriptor: {}
									},
									{
										name: 'plattenbau',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Construction.plattenbau' ),
										descriptor: {}
									},
									{
										name: 'passivehouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Construction.passivehouse' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild(
							ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() )
							.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.General.Construction' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
							.appendTo( this.m_General.Root() )
						),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Vollgeschosse
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.General.Fullbasement.Range )
					{
						if ( this.m_Data.Data.General.Fullbasement.Range[ i ] ) { values.push( i.toLowerCase() ); }
					}
					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'General.Fullbasement.Range',
								required: false,
								inline: 2,
								value: values,
								checkboxes:
								[
									{
										name: 'step1',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Fullbasement.Range.step1' ),
										descriptor: {}
									},
									{
										name: 'step2',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Fullbasement.Range.step2' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild(
							ui.$$.div().addClass( 'form-group' ).appendTo( this.m_Form.Root() )
							.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.General.Fullbasement' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
							.appendTo( this.m_General.Root() )
						),
						[ 'col-xs-12', 'col-md-4' ]
					);
				}

				let fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group clearfix' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Fullbasement.count' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_General.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.General.Fullbasement.Count,
						{
							name: 'General.Fullbasement.count',
							placeholder: '',
							required: false,
							min: 3
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				// Baujahr
				fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildYear' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_General.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.General.BuildYear,
						{
							name: 'General.BuildYear',
							placeholder: '',
							required: false,
							min: 1700
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				// KfW
				fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group clearfix' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.KfW' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_General.Root() );
				addObjDataInput(
					new ui.Form.TextInput(
						this.m_Data.Data.General.KfW || '',
						{
							name: 'General.kfw',
							placeholder: '',
							required: false
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				// Technik
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.General.Technique )
					{
						if ( this.m_Data.Data.General.Technique[ i ] ) { values.push( i.toLowerCase() ); }
					}
					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'General.Technique',
								required: false,
								inline: 3,
								value: values,
								checkboxes:
								[
									{
										name: 'conventional',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Technique.conventional' ),
										descriptor: {}
									},
									{
										name: 'ecological',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Technique.ecological' ),
										descriptor: {}
									},
									{
										name: 'enev',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Technique.enev' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.General.Technique' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_General.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Fenster
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.General.Window )
					{
						if ( this.m_Data.Data.General.Window[ i ] ) { values.push( i.toLowerCase() ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'General.Window',
								required: false,
								inline: 4,
								value: values,
								checkboxes:
								[
									{
										name: 'singleglazed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Window.singleglazed' ),
										descriptor: {}
									},
									{
										name: 'doubleglazed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Window.doubleglazed' ),
										descriptor: {}
									},
									{
										name: 'tripleglazed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Window.tripleglazed' ),
										descriptor: {}
									},
									{
										name: 'soundproofed',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Window.soundproofed' ),
										descriptor: {}
									},
									{
										name: 'mirrored',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Window.mirrored' ),
										descriptor: {}
									},
									{
										name: 'wood',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Window.wood' ),
										descriptor: {}
									},
									{
										name: 'alu',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Window.alu' ),
										descriptor: {}
									},
									{
										name: 'plastic',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.Window.plastic' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild(
							ui.$$.div().addClass( 'form-group clearfix' )
							.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.General.Window' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
							.appendTo( this.m_General.Root() )
						),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Bautenstand
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'General.ConstructionRate',
							required: false,
							inline: 3,
							value: this.m_Data.Data.General.ConstructionRate || undefined,
							radioButtons:
							[
								{
									value: 'underConstruction',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.ConstructionRate.underConstruction' ),
									descriptor: {}
								},
								{
									value: 'finished',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.ConstructionRate.finished' ),
									descriptor: {}
								},
								{
									value: 'Renovation',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.ConstructionRate.Renovation' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.General.ConstructionRate' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_General.Root() )
					),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Nutzungsfähigkeit
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Applicability.Occupation )
					{
						if ( this.m_Data.Data.Applicability.Occupation[ i ] ) { values.push( i.toLowerCase() ); }
					}

					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Applicability.Occupation',
								required: false,
								inline: 1,
								value: values,
								checkboxes:
								[
									{
										name: 'self',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Occupation.self' ),
										descriptor: {}
									},
									{
										name: 'foreign',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Occupation.foreign' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild(
							ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() )
							.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.Applicability.Occupation' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
							.appendTo( this.m_General.Root() )
						),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Bezugsstand
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'General.TenancyRate',
							required: false,
							inline: 3,
							value: this.m_Data.Data.General.TenancyRate || undefined,
							radioButtons:
							[
								{
									value: 'empty',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.TenancyRate.empty' ),
									descriptor: {}
								},
								{
									value: 'halffull',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.TenancyRate.halffull' ),
									descriptor: {}
								},
								{
									value: 'full',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.TenancyRate.full' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.General.TenancyRate' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_General.Root() )
					),
					[ 'col-xs-12', 'col-md-10' ]
				);

			}

			private showBuildingApplicability(): void
			{
				this.m_Applicability.clearTitle();
				this.m_Applicability.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.BUILDING.Applicability' ) );
				this.m_Applicability.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };

				// Verwertbarkeit
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'Applicability.Applicability',
							required: false,
							inline: 5,
							value: this.m_Data.Data.Applicability.Applicability || undefined,
							radioButtons:
							[
								{
									value: 'verywell',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Applicability.verywell' ),
									descriptor: {}
								},
								{
									value: 'good',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Applicability.good' ),
									descriptor: {}
								},
								{
									value: 'pleasable',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Applicability.pleasable' ),
									descriptor: {}
								},
								{
									value: 'enough',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Applicability.enough' ),
									descriptor: {}
								},
								{
									value: 'inadequate',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Applicability.inadequate' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.Applicability.Applicability' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_Applicability.Root() )
					),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Vermietbarkeit
				addObjDataInput(
					new ui.Form.RadioGroup(
						{
							name: 'Applicability.Lettability',
							required: false,
							inline: 5,
							value: this.m_Data.Data.Applicability.Lettability || undefined,
							radioButtons:
							[
								{
									value: 'verywell',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Lettability.verywell' ),
									descriptor: {}
								},
								{
									value: 'good',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Lettability.good' ),
									descriptor: {}
								},
								{
									value: 'pleasable',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Lettability.pleasable' ),
									descriptor: {}
								},
								{
									value: 'enough',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Lettability.enough' ),
									descriptor: {}
								},
								{
									value: 'inadequate',
									title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Lettability.inadequate' ),
									descriptor: {}
								}
							]
						}
					)
					.rebuild(
						ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.Applicability.Lettability' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
						.appendTo( this.m_Applicability.Root() )
					),
					[ 'col-xs-12', 'col-md-10' ]
				);

				// Mieten und Flächen
				let fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.append( ui.$$.h( 6, app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.Applicability.Letting' ) ).addClass( 'text-muted' ) )
				.addClass( 'form-group' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.RentMonthly' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_Applicability.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Applicability.RentMonthly,
						{
							name: 'Applicability.RentMonthly',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group clearfix' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.RentPercentageCommercial' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_Applicability.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Applicability.RentPercentageCommercial,
						{
							name: 'Applicability.RentPercentageCommercial',
							placeholder: '',
							required: false,
							min: 0,
							max: 100
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Area' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_Applicability.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Applicability.Area,
						{
							name: 'Applicability.Area',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group clearfix' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.AreaPercentageCommercial' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_Applicability.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Applicability.AreaPercentageCommercial,
						{
							name: 'Applicability.AreaPercentageCommercial',
							placeholder: '',
							required: false,
							min: 0,
							max: 100
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Brutto' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_Applicability.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Applicability.Brutto,
						{
							name: 'Applicability.Brutto',
							placeholder: '',
							required: false,
							min: 0
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				fg = ui.$$.div().appendTo( this.m_Form.Root() )
				.addClass( 'form-group clearfix' )
				.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.BruttoPercentageCommercial' ) ).addClass( 'control-label col-xs-12 col-md-2' ) )
				.appendTo( this.m_Applicability.Root() );
				addObjDataInput(
					new ui.Form.NumberInput(
						this.m_Data.Data.Applicability.BruttoPercentageCommercial,
						{
							name: 'Applicability.BruttoPercentageCommercial',
							placeholder: '',
							required: false,
							min: 0,
							max: 100
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-4' ]
				);

			}

			private showBuildingHeating(): void
			{
				this.m_Heating.clearTitle();
				this.m_Heating.addTitle( app.getMessage( 'Realtor.OBJECT.TITLE.BUILDING.Heating' ) );
				this.m_Heating.rebuild( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );

				// Heizung: Art
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Heating.KindOf )
					{
						if ( this.m_Data.Data.Heating.KindOf[ i ] ) { values.push( i.toLowerCase() ); }
					}

					const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Heating.KindOf',
								required: false,
								inline: 3,
								value: values,
								checkboxes:
								[
									{
										name: 'central',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.KindOf.central' ),
										descriptor: {}
									},
									{
										name: 'decentraletage',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.KindOf.decentralEtage' ),
										descriptor: {}
									},
									{
										name: 'decentralunit',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.KindOf.decentralUnit' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.Heating.KindOf' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Heating.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

				// Heizung: Medium
				{
					const values: string[] = [];

					for ( const i in this.m_Data.Data.Heating.Medium )
					{
						if ( this.m_Data.Data.Heating.Medium[ i ] ) { values.push( i ); }
					}
					const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };
					addObjDataInput(
						new ui.Form.CheckboxGroup(
							{
								name: 'Heating.Medium',
								required: false,
								inline: 4,
								value: values,
								checkboxes:
								[
									{
										name: 'Gas',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.Gas' ),
										descriptor: {}
									},
									{
										name: 'Oil',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.Oil' ),
										descriptor: {}
									},
									{
										name: 'Electricity',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.Electricity' ),
										descriptor: {}
									},
									{
										name: 'Pellet',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.Pellet' ),
										descriptor: {}
									},
									{
										name: 'PlantOil',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.PlantOil' ),
										descriptor: {}
									},
									{
										name: 'GeoThermalHeatPump',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.GeoThermalHeatPump' ),
										descriptor: {}
									},
									{
										name: 'AirHeatExchanger',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.AirHeatExchanger' ),
										descriptor: {}
									},
									{
										name: 'Coal',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.Coal' ),
										descriptor: {}
									},
									{
										name: 'Biomass',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.Biomass' ),
										descriptor: {}
									},
									{
										name: 'IrradiationHeating',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.IrradiationHeating' ),
										descriptor: {}
									},
									{
										name: 'solar',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.solar' ),
										descriptor: {}
									},
									{
										name: 'DistrictHeating',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.DistrictHeating' ),
										descriptor: {}
									},
									{
										name: 'WoodBilletManual',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.WoodBilletManual' ),
										descriptor: {}
									},
									{
										name: 'WoodBilletAutomatic',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Heating.Medium.WoodBilletAutomatic' ),
										descriptor: {}
									}
								]
							}
						)
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' ).appendTo( this.m_Form.Root() )
						.append( ui.$$.label().text( app.getMessage( 'Realtor.OBJECT.LABEL.BUILDING.Heating.Medium' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_Heating.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ]
					);
				}

			}

		}

	}
}
